import React from 'react';
import { Search, Sparkles, CheckCircle, ArrowRight } from 'lucide-react';
import { processSteps } from '../data/mock';

const iconMap = [
  Search,
  Sparkles,
  CheckCircle,
];

const ProcessSection = () => {
  return (
    <section id="processo" className="py-24 bg-gradient-to-b from-slate-900 to-slate-800 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-sky-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-sky-400/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-2 bg-sky-500/20 text-sky-300 rounded-full text-sm font-semibold mb-4">
            Il Nostro Metodo
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Come Lavoriamo
          </h2>
          <p className="text-lg text-slate-300">
            Il nostro processo di pulizia e sanificazione è suddiviso in tre fasi 
            principali per garantire risultati eccellenti.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-sky-500/50 to-transparent -translate-y-1/2" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {processSteps.map((step, index) => {
              const IconComponent = iconMap[index];
              return (
                <div
                  key={step.id}
                  className="relative group"
                >
                  {/* Card */}
                  <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300">
                    {/* Step number */}
                    <div className="absolute -top-5 left-8 w-10 h-10 bg-sky-500 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-sky-500/30">
                      {step.id}
                    </div>

                    {/* Icon */}
                    <div className="w-16 h-16 bg-sky-500/20 rounded-xl flex items-center justify-center mb-6 mt-4 group-hover:bg-sky-500/30 transition-colors">
                      <IconComponent className="w-8 h-8 text-sky-400" />
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-bold text-white mb-4">
                      {step.title}
                    </h3>
                    <p className="text-slate-400 leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow to next step */}
                  {index < processSteps.length - 1 && (
                    <div className="hidden lg:flex absolute top-1/2 -right-4 -translate-y-1/2 z-10">
                      <div className="w-8 h-8 bg-sky-500 rounded-full flex items-center justify-center">
                        <ArrowRight className="w-4 h-4 text-white" />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Certification Badge */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10">
            <div className="w-12 h-12 bg-sky-500 rounded-full flex items-center justify-center">
              <CheckCircle className="w-6 h-6 text-white" />
            </div>
            <div className="text-left">
              <div className="text-white font-bold">Certificazione AIISA</div>
              <div className="text-slate-400 text-sm">
                Tecnici altamente qualificati e aggiornati sulle migliori pratiche
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
